import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

type GuideKey = 'quant' | 'algorithm';

interface Props {
  type: GuideKey;
  bg?: string;
}

type DataItem = {
  label: string;
  link: string;
  image: string;
};

const data: Record<GuideKey, DataItem> = {
  quant: {
    label: '퀀트분석',
    link: '/quant-guide',
    image: '/assets/images/guide-landing/quant/hero_graphic_mobile.png',
  },
  algorithm: {
    label: '나만의 알고리즘',
    link: '/algorithm-guide',
    image: '/assets/images/guide-landing/algo/banner_graphic_mobile.png',
  },
};

function GuideSection({ type, bg }: Props) {
  const navigate = useNavigate();
  return (
    <Container $bg={bg}>
      <TextArea>
        <Title>
          땅집고옥션의
          <br />
          <span>{data[type].label}</span>이 궁금하신가요?
        </Title>
        <Button onClick={() => navigate(data[type].link)}>
          {data[type].label} 이용가이드
          <IconButton>
            <img src="/assets/images/arrow/arrow-right-purple.svg" alt="" />
          </IconButton>
        </Button>
      </TextArea>
      <img
        // src="/assets/images/quant/guide/hero_graphic_mobile.png"
        src={data[type].image}
        alt=""
        width={80}
        height={80}
      />
    </Container>
  );
}

export default GuideSection;

const Container = styled.div<{ $bg?: string }>`
  display: flex;
  padding: 16px;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;
  border-radius: 16px;
  background: ${({ $bg }) => ($bg ? $bg : '#f7f8fc')};
`;

const TextArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: flex-start;
`;

const Title = styled.div`
  color: #222;
  font-size: 16px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.32px;

  & > span {
    font-weight: 700;
  }
`;

const Button = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;

  color: #1f0a8a;
  font-size: 14px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.28px;
`;

const IconButton = styled.div`
  display: flex;
  padding: 8px;
  align-items: center;
  border-radius: 20px;
  background: #fff;
`;
